import React, {useEffect} from 'react'
import { Col, Row } from 'antd'
import { connect } from 'react-redux'
import Layout from '../../components/Layout'
import actions from '../../redux/actions'
import Divider from '../../components/Divider'
import styled from 'styled-components'

import districtsData from '../../assets/data/district.json';


const Text = styled.p`
  font-size: 18px;
  line-height: 24.3px;
`

const StyledCol = styled(Col)`
  margin: 1rem 0 !important;
`

const District = (props) => {
  const provinceId = props.userInfomations.provinceId;
  const handleClick = (id,value) => {
    props.setDistrict(id,value)
    props.history.push('/select-sub-district');
  }

  useEffect(() => window.scrollTo(0,0));

  return (
    <Layout title={'อำเภอ/เขต'} backIcon={true} onClick={() => props.history.goBack()}>
      <h4 style={{marginTop: '2rem', marginBottom: '1rem'}}>กรุณาเลือกอำเภอ/เขต</h4>
      <Row>
        {
          districtsData.map(element => {
            if(provinceId === element.province_id) {
              return (
                <StyledCol key={element.id}>
                <Text onClick={() => handleClick(element.id,element.th)}>{element.th}</Text>
                <Divider floatRight={true}/>
              </StyledCol>
              )
            } else {
              return null
            }
          })
        }
      </Row>
    </Layout>
  )
}

const mapDispatchToProps = {
  setDistrict: actions.setDistrict,
}

const mapStateToProps = (state) => {
  return {
    userInfomations: state.userInfomations
  }
}

const DistrictWithConnect = connect(mapStateToProps, mapDispatchToProps)(District)

export default DistrictWithConnect
